import React, { useContext } from "react";
import CommonModal from "./CommonModal";
import LoginForm from "./LoginForm";
import { TranslationContext } from "@src/components/translation/TranslationContext";

const ParentLoginModal = (props) => {
  const t = useContext(TranslationContext);

  return (
    <CommonModal headerText={t.translate("components.login.log_in_to_classdojo")} {...props}>
      <LoginForm userType="parent" closeModal={props.closeModal} />
    </CommonModal>
  );
};

export default ParentLoginModal;
